import { useState } from "react";
import { faqItems } from "@/mocks/comic";

function FaqSchema() {
  const data = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqItems.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />;
}

export default function Faq() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="bg-background-50">
      <FaqSchema />
      <div className="container-paper py-14 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <span className="inline-flex items-center gap-2 text-xs tracking-[0.18em] text-primary-600">
              <i className="ri-question-answer-line text-sm leading-none" aria-hidden="true"></i>
              常见问题
            </span>
            <h2 className="mt-3 font-display text-3xl text-foreground-950 md:text-4xl">
              关于纸质阅读，你可能想问
            </h2>
            <p className="mt-3 text-sm leading-7 text-foreground-600">
              初次接触纸盒漫画网的朋友，常会问到这些。如果还有别的问题，
              欢迎通过下方「联系我们」或订阅反馈与我们聊聊。
            </p>
            <a
              href="#subscribe"
              className="mt-6 inline-flex items-center gap-2 rounded-md border border-primary-300 bg-background-50 px-5 py-2.5 text-sm whitespace-nowrap text-primary-700 transition-colors hover:bg-primary-500 hover:text-background-50"
            >
              <i className="ri-chat-3-line text-base leading-none" aria-hidden="true"></i>
              向我们提问
            </a>
          </div>

          <div className="lg:col-span-3">
            <div className="space-y-3">
              {faqItems.map((item, idx) => {
                const open = openIdx === idx;
                return (
                  <div
                    key={item.q}
                    className={`overflow-hidden rounded-lg border bg-background-100 transition-colors ${
                      open ? "border-primary-300" : "border-background-200"
                    }`}
                  >
                    <button
                      type="button"
                      onClick={() => setOpenIdx(open ? -1 : idx)}
                      aria-expanded={open}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="text-sm font-medium leading-6 text-foreground-950 md:text-base">
                        {item.q}
                      </span>
                      <span
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-primary-600 transition-transform ${
                          open ? "rotate-45" : ""
                        }`}
                      >
                        <i className="ri-add-line text-xl leading-none" aria-hidden="true"></i>
                      </span>
                    </button>
                    {open && (
                      <div className="px-5 pb-5">
                        <p className="text-sm leading-7 text-foreground-600">{item.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}